import React, { forwardRef } from 'react';
import Input from '../Input/Input';

const Textarea = forwardRef((props, ref) => <Input ref={ref} {...props} type="textarea" />);

Textarea.displayName = 'Textarea';

export default Textarea;
